/* NOWA advertorial — geri sayım sayacı ve scroll progress bar */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* ── Geri sayım ──
     Her zaman içinde bulunulan günün sonuna (yerel saatle 24:00) sayar.
     Gece yarısını geçince otomatik olarak ertesi günün sonuna döner,
     böylece kalan süre daima 24 saatin altında kalır ve HH·MM·SS
     düzeni bozulmaz. */
  function initCountdown(bar) {
    var h = bar.querySelector('[data-adv-h]');
    var m = bar.querySelector('[data-adv-m]');
    var s = bar.querySelector('[data-adv-s]');
    if (!h || !m || !s) return;

    function endOfToday() {
      var now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0).getTime();
    }

    var end = endOfToday();

    function tick() {
      var diff = end - Date.now();

      // Gece yarısı geçildi → hedefi ertesi günün sonuna taşı
      if (diff <= 0) {
        end = endOfToday();
        diff = end - Date.now();
      }

      h.textContent = pad(Math.floor(diff / 36e5));
      m.textContent = pad(Math.floor((diff % 36e5) / 6e4));
      s.textContent = pad(Math.floor((diff % 6e4) / 1e3));
    }

    tick();
    var id = setInterval(tick, 1000);

    bar.addEventListener('adv:teardown', function () {
      clearInterval(id);
    });
  }

  /* ── Scroll progress bar ── */
  function initProgress(bar) {
    var el = bar.querySelector('[data-adv-progress]');
    if (!el) return;

    var ticking = false;

    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? Math.min(100, (window.scrollY / max) * 100) : 0;
      el.style.width = pct + '%';
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ── Bar yüksekliği ──
     Sabit (fixed) barın altındaki boşluk, barın gerçek yüksekliğine
     eşitlenir. Uzun çeviriler veya farklı font metrikleri barı
     büyüttüğünde içeriğin altına girmesini önler. */
  function initBarHeight(bar) {
    var annbar = bar.querySelector('.annbar');
    if (!annbar) return;

    function sync() {
      var hgt = Math.round(annbar.getBoundingClientRect().height);
      if (hgt > 0) bar.style.setProperty('--adv-bar-h', hgt + 'px');
    }

    sync();

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(sync);
      ro.observe(annbar);
      bar.addEventListener('adv:teardown', function () {
        ro.disconnect();
      });
    } else {
      window.addEventListener('resize', sync, { passive: true });
    }

    // Fontlar geç yüklenirse bar yüksekliği değişebilir
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-adv-bar]').forEach(function (bar) {
      if (bar.dataset.advReady === 'true') return;
      bar.dataset.advReady = 'true';
      initBarHeight(bar);
      initCountdown(bar);
      initProgress(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Tema editörü desteği */
  document.addEventListener('shopify:section:unload', function (e) {
    var bar = e.target.querySelector('[data-adv-bar]');
    if (bar) bar.dispatchEvent(new CustomEvent('adv:teardown'));
  });
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
